<template>
  <base-legal-page
    kicker="Tiozão"
    title="Política de Privacidade do Tiozão"
    updated="setembro de 2026"
    updated-label="Última atualização"
  >
    <h2>1. Resumindo</h2>
    <p>
      O Tiozão não tem conta nem login e não coleta informações pessoais sobre você. Só três coisas saem do seu aparelho: o necessário para processar uma compra (feito pela Apple e pelo nosso provedor de pagamentos), uma verificação diária de versão nova e contagens anônimas de uso, ligadas a um código aleatório, não a você.
    </p>

    <h2>2. Informações que coletamos</h2>
    <p>
      <strong>Nenhuma informação pessoal.</strong> O Tiozão não pede seu nome, seu e-mail nem qualquer outro dado pessoal, e não há onde fazer login. Não montamos um perfil seu e não usamos publicidade nem ferramentas de rastreamento.
    </p>
    <p>
      <strong>Eventos de uso anônimos.</strong> O app envia ao nosso próprio servidor (api.hackerhang.com) registros curtos de eventos: um nome de uma lista fixa (o app foi aberto, uma resposta foi revelada, uma piada foi salva, compartilhada ou avaliada) com alguns detalhes, como o id da piada, o tema ou uma nota, além da versão do app e da plataforma. Cada instalação gera um código aleatório na primeira abertura, para sabermos quantas instalações estão ativas; ele não é o identificador do seu aparelho nem o identificador de publicidade, e não se liga a nada sobre você. Os eventos nunca contêm o que você digitou ou leu.
    </p>
    <p>
      <strong>Verificação de versão.</strong> Uma vez por dia o app pergunta ao mesmo servidor se existe uma versão mais nova, enviando só a versão do app e a plataforma.
    </p>

    <h2>3. O que fica no seu aparelho</h2>
    <p>
      O app guarda algumas informações localmente para funcionar do jeito que você espera:
    </p>
    <ul>
      <li><strong>Suas piadas salvas</strong> e as notas de aff que você deu</li>
      <li><strong>Seu histórico de leitura:</strong> quais piadas você já viu, para as três do dia continuarem novas e o Sobre mostrar quantas você já leu</li>
      <li><strong>Suas configurações:</strong> preferências como os efeitos sonoros</li>
    </ul>
    <p>
      Tudo isso fica só no seu aparelho. Nunca é enviado para nós, nunca é copiado para nossos servidores e nunca é compartilhado. Nós não conseguimos ver. Apagar o app apaga tudo.
    </p>

    <h2>4. Compras</h2>
    <p>
      O Tiozão oferece uma compra única, dentro do app, que libera todas as piadas. As compras são processadas pela Apple, sob a política de privacidade da própria Apple. Nunca vemos seus dados de pagamento.
    </p>
    <p>
      Para lembrar que você comprou mesmo depois de reinstalar ou trocar de aparelho, usamos o RevenueCat, um serviço de gestão de compras. O RevenueCat recebe um identificador anônimo gerado no seu aparelho, junto com o comprovante de compra emitido pela Apple. Também anexamos o mesmo código aleatório de instalação descrito acima, para que a restauração da compra numa nova instalação possa ser ligada à compra anterior. O RevenueCat não recebe seu nome, seu e-mail nem nada do que você leu, salvou ou fez no app. A política de privacidade deles está em
      <a
        href="https://www.revenuecat.com/privacy"
        target="_blank"
        rel="noopener"
      >revenuecat.com/privacy</a>.
    </p>
    <p>
      Além das compras, da verificação de versão e dos eventos anônimos acima, o app não faz nenhuma outra requisição de rede. As piadas vêm dentro do app e funcionam sem internet.
    </p>

    <h2>5. Permissões</h2>
    <p>
      O Tiozão não acessa suas fotos, contatos, localização, agenda ou dados de saúde. Não pede acesso ao microfone e nunca grava nem escuta nada. Quando você compartilha uma piada, é você quem escolhe para onde ela vai, pela tela de compartilhamento do próprio iOS. O app não usa o identificador de publicidade e não rastreia você em outros apps ou sites.
    </p>

    <h2>6. Privacidade das crianças</h2>
    <p>
      O Tiozão é um app de piadas para o público em geral, incluindo crianças. O app não coleta informações pessoais de ninguém, incluindo crianças menores de 13 anos: nada do que você lê, salva ou revela sai do seu celular, e as únicas coisas que saem são as contagens anônimas e a verificação de versão descritas acima.
    </p>

    <h2>7. Seus direitos</h2>
    <p>
      Os eventos de uso que guardamos são anônimos e não podem ser ligados a você, então não há nada sobre você para mostrarmos, corrigirmos ou apagarmos, inclusive nos termos da LGPD. Você pode remover tudo o que o app guardou no seu celular, incluindo o código aleatório de instalação, apagando o app. Se você comprou o Tiozão Completo e reinstalar, "Restaurar compra" na tela Sobre recupera a compra pela Apple.
    </p>

    <h2>8. Mudanças nesta política</h2>
    <p>
      Se o app passar a coletar qualquer informação além do que está descrito aqui, esta página será atualizada antes de a mudança ser lançada, e a data de "Última atualização" acima mudará junto.
    </p>

    <h2>9. Fale conosco</h2>
    <p>Se tiver qualquer dúvida sobre esta política, fale com a gente:</p>
    <div class="hh-legal__contact">
      <div><strong>E-mail:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Site:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'TiozaoPrivacy',

    metaInfo: { title: 'Política de Privacidade do Tiozão' },
  }
</script>
